import {
  RISK_CATEGORIES,
  RISK_FILTER_OTHERS,
  getKnownRiskCategory,
} from '../../constants/riskCategories.js';

export const RISK_LEVEL_CANONICAL = ['High', 'Medium', 'Low'] as const;
export type RiskLevelCanonical = (typeof RISK_LEVEL_CANONICAL)[number];

/** Canonical risk levels for draft table `<select>` (matches {@link riskFormSchema}). */
export const RISK_LEVEL_SELECT_OPTIONS: ReadonlyArray<{ value: RiskLevelCanonical; label: string }> = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
];

export const RISK_LEVEL_FILTER_OPTIONS: ReadonlyArray<{ value: 'all' | 'high' | 'moderate' | 'low'; label: string }> = [
  { value: 'all', label: 'All Risk Levels' },
  { value: 'high', label: 'High' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'low', label: 'Low' },
];

/** Categories allowed in the risk form + bulk draft (includes “Others”). */
export const RISK_CATEGORY_DRAFT_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  ...RISK_CATEGORIES.map((value) => ({ value, label: value })),
  { value: RISK_FILTER_OTHERS, label: RISK_FILTER_OTHERS },
];

/**
 * Map spreadsheet / API extraction text to a canonical risk level, or '' if unknown.
 */
export function normalizeRiskLevelForDraft(raw: unknown): RiskLevelCanonical | '' {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if ((RISK_LEVEL_CANONICAL as readonly string[]).includes(s)) return s as RiskLevelCanonical;
  const lower = s.toLowerCase();
  // Word-boundary checks so values like "Higher" or "highest" do not map to High.
  if (lower === 'h' || /\bhigh\b/.test(lower)) return 'High';
  if (lower === 'm' || /\bmedium\b/.test(lower) || /\bmed\b/.test(lower)) return 'Medium';
  if (lower === 'l' || /\blow\b/.test(lower)) return 'Low';
  return '';
}

/**
 * Map extraction text to a known category value, or '' if unknown (user must pick from the list).
 */
export function normalizeRiskCategoryForDraft(raw: unknown): string {
  const known = getKnownRiskCategory(raw);
  if (known) return known;
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if (/^others?$/i.test(s)) return RISK_FILTER_OTHERS;
  return '';
}
